import styled from 'styled-components';

import { IAddOn, IGlassesPackage } from '../../types';
import { PriceLine } from './PriceLine';
import { PriceDivider } from './PriceDivider';
import { breakpoints } from '../../constants';
import { applyDiscount, getPricingDetails } from '../../utils';

interface IProps {
    className?: string;
    selectedPackage: IGlassesPackage;
    selectedAddOns?: IAddOn[];
}

const BasePricingOverview = ({
    className,
    selectedPackage,
    selectedAddOns,
}: IProps) => {
    const pricingDetails = getPricingDetails(selectedPackage, selectedAddOns);

    if (!pricingDetails) return null;

    const { framePrice, glassesPrice, total } = pricingDetails;

    const discountPercentage = selectedPackage.discountPercentage ?? 0;
    const hasDiscount = discountPercentage > 0;

    return (
        <div className={className}>
            <h3>Rekenvoorbeeld</h3>
            <PriceDivider />
            <PriceLine item="Zonnebril montuur" price={framePrice} />
            <PriceLine
                item="Glaspakket"
                price={glassesPrice}
                priceFrom={hasDiscount ? selectedPackage.priceInt : undefined}
                starAmount={selectedPackage.strength}
                subLabel={
                    hasDiscount
                        ? `${discountPercentage}% korting op glas *`
                        : undefined
                }
            />
            {selectedAddOns &&
                selectedAddOns.map((selectedAddOn) => {
                    const substring = '- niet combineerbaar';

                    const addOnName = selectedAddOn.name.includes(substring)
                        ? selectedAddOn.name.replace(substring, '')
                        : selectedAddOn.name;

                    const addOnPrice = hasDiscount
                        ? applyDiscount(
                              selectedAddOn.priceInt,
                              discountPercentage
                          )
                        : selectedAddOn.priceInt;

                    return (
                        <PriceLine
                            item={addOnName}
                            key={selectedAddOn.id}
                            price={addOnPrice}
                            priceFrom={
                                hasDiscount && selectedAddOn.priceInt > 0
                                    ? selectedAddOn.priceInt
                                    : undefined
                            }
                        />
                    );
                })}
            <PriceDivider />
            <PriceLine bold isTotal item="Je betaalt" price={total} />
        </div>
    );
};

export const PricingOverview = styled(BasePricingOverview)`
    display: flex;
    flex-direction: column;
    padding: 30px;

    @media (${breakpoints.mediumMin}) {
        flex: 0 0 55%;
    }

    h3 {
        font-size: 20px;
        margin-bottom: 15px;
    }
`;
